import { useNavigate } from '@tanstack/react-router';
import { NextSectionButtonProps } from '../../types/Generics/NextSectionButtonProps';

export const NextSection = (props: NextSectionButtonProps) => {
  const navigate = useNavigate();

  return (
    <button
      id={'nav-forward'}
      className="m-2 place-self-center rounded-md bg-red-900 px-4 py-2 text-xl text-white hover:bg-red-950 disabled:border-slate-200 disabled:bg-slate-50 disabled:text-slate-500 disabled:shadow-none sm:px-8 sm:py-3"
      type={'button'}
      onClick={() => navigate({ to: props.to })}
    >
      Next Section
    </button>
  );
};
